module.exports = __webpack_public_path__ + "static/media/PM45.cf22a8fd.png";